import React from 'react';
import {
  Button,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from 'reactstrap';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import { yupResolver } from '@hookform/resolvers/yup';
import acceptIcon from '../../../../assets/images/performance/acceptIcon.png';
import { performanceHeaderClose } from '../../../../store/apis/performanceService';
import { initialValues, validationSchema } from './constants';
import { DatePicker } from '../../../../components/Common';

function AcceptSubmitModal({
  isOpen,
  toggle,
  selectedEmployee,
  refetchPerformanceHeader,
  refetchPerformanceDetails,
}) {
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
  });

  const { mutate: headerSubmit } = useMutation({
    mutationFn: performanceHeaderClose,
    onSuccess: () => {
      reset();
      toggle();
      if (refetchPerformanceHeader) {
        refetchPerformanceHeader();
      }
      if (refetchPerformanceDetails) {
        refetchPerformanceDetails();
      }
      toast.success('Data Submitted successfully!', {
        className: 'toast-success',
      });
    },
    onError: error => {
      toast.error(error?.message || 'Failed to submit data', {
        className: 'toast-error',
      });
    },
  });

  const onSubmit = value => {
    const payload = {
      employeeId: selectedEmployee?.value || selectedEmployee?.EmpCd?.trim(),
      userId: '',
      feedbackDate: value?.feedbackDate,
      fedbackComments: value?.comments,
    };
    headerSubmit(payload);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="custom-Submit-modal"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>
        <div className="addKpiHeader">
          <img
            alt=""
            src={acceptIcon}
            style={{ width: '60px', height: '60px' }}
          />
          <div className="title">Accept & Submit</div>
        </div>
      </ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <div className="modalSubmitBody">
            <div className="submitInput">
              <Label>
                Feedback Meeting Date
                <span className="text-danger"> *</span>
              </Label>
              <Controller
                name="feedbackDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    className={`external-filter-input ${errors.feedbackDate ? 'is-invalid' : ''}`}
                    error={!!errors.feedbackDate}
                    title="Select Feedback Meeting date"
                  />
                )}
              />
              {errors.feedbackDate && (
                <span className="text-danger">
                  {errors.feedbackDate.message}
                </span>
              )}
            </div>
            <div className="submitInput">
              <Label>
                My Comments
                <span className="text-danger"> *</span>
              </Label>
              <Controller
                name="comments"
                control={control}
                render={({ field }) => (
                  <Input
                    type="textarea"
                    placeholder="Enter comment"
                    cols={90}
                    className="form-control external-filter-input"
                    {...field}
                    title="Enter feedback meeting comments"
                  />
                )}
              />
              {errors.comments && (
                <span className="text-danger">{errors.comments.message}</span>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="modalFooter">
          <Button
            className="item custom-light-btn"
            onClick={() => {
              reset();
              toggle();
            }}
            type="button"
          >
            Cancel
          </Button>
          <Button className="item custom-btn" type="submit">
            Accept
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default AcceptSubmitModal;
